module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="widget_header_region"></div>\n<div id="interactive_region"></div>\n<div aria-label="Carousel of images with text descriptions and social media handles." id="coverflow_widget" class="wrap" role="region">\n	<div id="frame" class="coverflow_frame">\n	</div>\n</div>\n';

}
return __p
}